import { getServerSideMonolithClient } from '~/framework';
import { bff, createBFFHandlers } from '~/framework/bff';
import { listSignoffSigners } from '~/monolith-api';
import { z } from 'zod';

export type ListSignoffSignersOptions = {
   limit?: number;
   offset?: number;
   searchTerm?: string;
};

const listSignoffSignersSchema = z.object({
   stageAssessmentId: z.number(),
   limit: z.number().optional(),
   offset: z.number().optional(),
   searchTerm: z.string().optional(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { stageAssessmentId, limit, offset, searchTerm } = listSignoffSignersSchema.parse(
         req.body
      );
      const monolithClient = getServerSideMonolithClient(req);
      const result = await listSignoffSigners(stageAssessmentId, {
         apiClient: monolithClient,
         limit: limit,
         offset: offset,
         searchTerm: searchTerm,
      });
      res.status(200).json(result);
   },
});

export const listSignoffSignersFromClient = (
   stageAssessmentId: number,
   { limit, offset, searchTerm }: ListSignoffSignersOptions
): ReturnType<typeof listSignoffSigners> => {
   return bff()
      .post('/signoffs/listSignoffSigners', {
         stageAssessmentId,
         limit,
         offset,
         searchTerm,
      })
      .catch(error => {
         if (error.response.data.message !== 'Endpoint is disabled') {
            throw error;
         }
      })
      .then(response => response?.data);
};

export type ListSignoffSignersErrorCode = 'signoffs.list_signoff_signers_error';
